import {PropsWithChildren} from "react";

import {Card} from "@/components/card/Card.tsx";
import {NavTabs} from "@/components/navTabs/NavTabs.tsx";
import {RUMChartTab, RUMChartTabLabels} from "@/pages/rum/v2/details/graphs/types.ts";

interface RumCheckGraphsEmptyProps extends PropsWithChildren {
  className?: string;
  activeTab: RUMChartTab;
}

export const RumCheckGraphsEmpty = ({className, activeTab, children}: RumCheckGraphsEmptyProps) => {
  return (
    <Card variant="white" className={className}>
      <NavTabs
        className="border-0"
        items={[
          {title: RUMChartTabLabels[RUMChartTab.PAGE_LOAD_TIME], id: RUMChartTab.PAGE_LOAD_TIME},
          {title: RUMChartTabLabels[RUMChartTab.AJAX_LOAD_TIME], id: RUMChartTab.AJAX_LOAD_TIME},
          {title: RUMChartTabLabels[RUMChartTab.ERRORS], id: RUMChartTab.ERRORS},
          {title: RUMChartTabLabels[RUMChartTab.BOUNCE_RATE], id: RUMChartTab.BOUNCE_RATE},
        ]}
        selectedId={activeTab}
        selectTab={() => {}}
      />
      {children}
    </Card>
  );
};
